import React from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import {
	fullScreenPlugin,
	RenderEnterFullScreenProps,
} from "@react-pdf-viewer/full-screen";
import "@react-pdf-viewer/full-screen/lib/styles/index.css";
import clsx from "clsx";

import { Button, Skeleton } from "components";
import { useLoader } from "hooks";

import { ReactComponent as FullScreenIcon } from "static/images/full-screen-icon.svg";
import styles from "./pdfReport.module.scss";

type PdfFileProps = {
	pdfFile: string | undefined;
	classNameContainer?: string;
	classNameLoading?: string;
	reportTitle?: string;
	isLoading: boolean;
	canShowHeader?: boolean;
	defaultScale?: number;
};

const PdfFile = ({
	reportTitle = "",
	pdfFile,
	classNameContainer,
	classNameLoading,
	isLoading,
	defaultScale = 1.6,
	canShowHeader = false,
}: PdfFileProps) => {
	const Loader = useLoader(isLoading);

	const fullScreenPluginInstance = fullScreenPlugin();
	const { EnterFullScreen } = fullScreenPluginInstance;

	return (
		<div className={` ${clsx(classNameContainer, classNameLoading)}`}>
			<Loader
				skeleton={<Skeleton width="100%" height="100%" />}
				component={
					<>
						{pdfFile && (
							<>
								<Worker workerUrl="https://unpkg.com/pdfjs-dist@3.8.162/build/pdf.worker.min.js">
									{canShowHeader && (
										<div className={styles.reportHeader}>
											<h6 className={styles.reportTitle}>
												{reportTitle}
											</h6>
											<EnterFullScreen>
												{(
													props: RenderEnterFullScreenProps,
												) => {
													return (
														<Button
															variant="secondary"
															minWidth="auto"
															iconPosition="right"
															icon={
																<FullScreenIcon
																	className={
																		styles.btnIcon
																	}
																/>
															}
															className="pr-0"
															onClick={
																props.onClick
															}
															value="full screen"
															disabled={isLoading}
														/>
													);
												}}
											</EnterFullScreen>
										</div>
									)}

									<Viewer
										fileUrl={pdfFile}
										theme="dark"
										defaultScale={defaultScale}
										plugins={[fullScreenPluginInstance]}
									/>
								</Worker>
							</>
						)}
					</>
				}
			/>
		</div>
	);
};

export default PdfFile;
